import React, { Component } from "react";
import { fire } from "../../Firebase/firebase";
import Geocode from "react-geocode";
import TennisBall from "../../../img/tennisBall.png";
import BoneIcon1 from "../../../img/boneIcon-01.png";
import BoneIcon2 from "../../../img/boneIcon-02.png";

const boneIcons = {
  true: BoneIcon1,
  false: BoneIcon2
};

export default class ProfileModal extends Component {
  constructor(props) {
    super(props);

    this.state = {
      user: {
        name: null,
        gender: null,
        size: null,
        personality: null,
        avatar: null,
        location: null
      },

      isBoneGiven: false,
      isBallThrown: false
    };
    this.getLocation = this.getLocation.bind(this);
  }

// With the ID gotten from the previous component, pull data of the dog whose modal has been opened.
  componentDidMount() {
    Geocode.setApiKey("AIzaSyDCyEhbwIpYZ320wJTk_s_l2ECstVJLrzs");
    var ref = fire.database().ref(`users/` + this.props.id);

    ref.on(
      "value",
      snap => {
        const userID = snap.key;
        const dogName = snap.val() && snap.val().name;
        const size = snap.val() && snap.val().size;
        const gender = snap.val() && snap.val().gender;
        const personality = snap.val() && snap.val().personality;
        const avatar = snap.val() && snap.val().avatar_url;
        const latitude = snap.val() && snap.val().coords.latitude;
        const longitude = snap.val() && snap.val().coords.longitude;
        const visibility = snap.val() && snap.val().visibility;

        this.setState(
          {
            user: {
              name: dogName,
              gender: gender,
              size: size,
              personality: personality,
              avatar: avatar,
              latitude: latitude,
              longitude: longitude,
              visibility: visibility,
              userID: userID
            }
          },
          () => {
            // Get more info for the modal
            this.getFavouriteStatus();
            this.getLocation();
          }
        );
      },
      function(error) {
        console.log("Error: " + error.code);
      }
    );
  }

//Use googles geolocation API to get a readable format of the user location
  getLocation() {
    if (this.state.user.visibility === true) {
      Geocode.fromLatLng(
        this.state.user.latitude.toString(),
        this.state.user.longitude.toString()
      ).then(
        response => {
          const address = response.results[0].formatted_address;
          this.setState({ location: address });
        },
        error => {
          console.error(error);
        }
      );
    } else {
      this.setState({ location: "Location unknown" });
    }
  }

// Set the colour of the bone according to whether or not this user is in the current users favourites
  getFavouriteStatus = () => {
    let uid = fire.auth().currentUser.uid;
    let query = fire
      .database()
      .ref("users/" + uid + "/favourite_users")
      .orderByKey();

    query.once("value").then(snapshot => {
      snapshot.forEach((childSnapshot, data) => {
        let name = childSnapshot.val().name;

        if (childSnapshot.val() !== null && name === this.state.user.name) {
          this.setState({ isBoneGiven: true });
        }
      });
    });
  };

// Toggle the image, if isBoneGiven is toggled to true, the user is favourited, and if not they are deleted
  toggleImage = () => {
    this.setState(
      {
        isBoneGiven: !this.state.isBoneGiven
      },
      function() {
        if (this.state.isBoneGiven === true) {
          this.handleFavourite();
        } else {
          this.handleDeleteFavourite();
        }
      }
    );
  };

  handleFavourite = () => {
    let uid = fire.auth().currentUser.uid;
    fire
      .database()
      .ref("users/" + uid + "/favourite_users")
      .push({
        name: this.state.user.name,
        uid: this.state.user.userID,
        avatar: this.state.user.avatar
      })
      .catch(error => {
        console.log(error);
      });
    console.log("Entry made");
  };

  handleDeleteFavourite = () => {
    let uid = fire.auth().currentUser.uid;
    let query = fire
      .database()
      .ref("users/" + uid + "/favourite_users")
      .orderByKey();
    let ref = fire.database().ref("users/" + uid + "/favourite_users");

    query.once("value").then(snapshot => {
      snapshot.forEach((childSnapshot, data) => {
// If the user is found in the favourites, the key is removed
        if (childSnapshot.val() === this.state.user.name) {
          let key = childSnapshot.key;
          ref.child(key).remove();
        }
      });
    });
  };

// True corresponds to a filled bone and viceversa
  getImageName = () => (this.state.isBoneGiven ? "true" : "false");

  throwBall = () => {
    this.setState(
      {
        isBallThrown: !this.state.isBallThrown
      },
      function() {
        if (this.state.isBallThrown === true) {
          this.handleBallThrow();
        } else {
          console.log("Ball not thrown");
        }
      }
    );
  };

  handleBallThrow = () => {
    let uid = fire.auth().currentUser.uid;
    fire
      .database()
      .ref("users/" + this.state.user.userID + "/balls_caught")
      .push({
        name: this.props.currentUser.name,
        uid: uid,
        avatar: this.props.currentUser.avatar
      })
      .catch(error => {
        console.log(error);
      });
  };

  getTextColor = () => (this.state.isBallThrown ? "#6dc130" : "grey");

  render() {
    // Call these functions to determine the UI
    const imageName = this.getImageName();
    const textColor = this.getTextColor();

    return (
      <div className="profile-modal">
        <button
          className="close-button float-right"
          onClick={this.props.handleClose}
        >
          Close
        </button>
        <div>
          <h1 id="profile-modal-title">{this.state.user.name}</h1>
          <img
            src={boneIcons[imageName]}
            id="bone"
            alt="fireSpot"
            onClick={this.toggleImage}
          />
          <h4 id="profile-location">{this.state.location}</h4>
        </div>

        <img alt="dog profile" id="avatar-popup" src={this.state.user.avatar} />
        <div className="d-inline profile-data">
          <p className="profile-modal-info">{this.state.user.size}</p>
          <p className="profile-modal-info">{this.state.user.personality}</p>
          <img
            src={TennisBall}
            style={{ width: 20, display: "inline" }}
            alt="fireSpot"
          />
          <button
            id="throw-ball"
            style={{ textTransform: "none", color: textColor }}
            onClick={this.throwBall}
            disabled = {this.state.isBallThrown}
          >
            {this.state.isBallThrown ? "Ball thrown!  " : "Throw a ball!"}
          </button>
        </div>
      </div>
    );
  }
}
